export default __webpack_public_path__ + "static/media/b1.4874571e.webp";